import type { SearchResult } from '@cash-web/support/ui-components'

export const recommendedArticles: SearchResult[] = [
  {
    document_id: 'cash-help-article-3130',
    title: 'Access Old Account',
    preview:
      'If you are having trouble accessing an old account, it may be associated with another phone or email address.',
    url: 'http://cash.app/help/3130',
  },
  {
    document_id: 'cash-help-article-3074',
    title: "Withdrawal wasn't Instant",
    preview: "If your debit card doesn't accept Instant Deposit, you will be refunded any Instant Deposit fees",
    url: 'https://cash.app/help/us/en-us/3074-cash-out-not-instant',
  },
  {
    document_id: 'cash-help-article-3123',
    title: 'What is a $Cashtag?',
    preview: 'A $Cashtag is a unique identifier for individuals and businesses using Cash App',
    url: 'https://cash.app/help/us/en-us/3123-cashtags',
  },
  {
    document_id: 'cash-help-article-3051',
    title: 'Canceling a Payment',
    preview: "Cash App payments are instant and usually can't be canceled.",
    url: 'https://cash.app/help/us/en-us/3051-cancel-a-payment',
  },
]
